import React, { useState } from 'react';
import './Environment.css';

const Environment = ({ project }) => {
  const [selectedPreset, setSelectedPreset] = useState('Custom');
  const [date, setDate] = useState('9/21/2017');
  const [time, setTime] = useState('12:30');
  const [useSoftShadows, setUseSoftShadows] = useState(true);
  const [enableShadows, setEnableShadows] = useState(true);
  const [shadowIntensity, setShadowIntensity] = useState(0.8);
  const [lightingIntensity, setLightingIntensity] = useState(0.9);

  const presets = [
    { id: 'custom', name: 'Custom', icon: 'fas fa-sliders-h' },
    { id: 'morning', name: 'Morning', icon: 'fas fa-sun' },
    { id: 'midday-clear', name: 'Midday Clear', icon: 'fas fa-sun' },
    { id: 'midday-cloudy', name: 'Midday Cloudy', icon: 'fas fa-cloud-sun' },
    { id: 'midday-overcast', name: 'Midday Overcast', icon: 'fas fa-cloud' },
    { id: 'evening', name: 'Evening', icon: 'fas fa-sun' }
  ];

  return (
    <div className="environment-container">
      <div className="environment-section">
        <div className="section-header">
          <i className="fas fa-cog"></i>
          <h4>Presets</h4>
        </div>
        <div className="presets-grid">
          {presets.map(preset => (
            <button
              key={preset.id}
              className={`preset-btn ${selectedPreset === preset.name ? 'active' : ''}`}
              onClick={() => setSelectedPreset(preset.name)}
            >
              <i className={preset.icon}></i>
              <span>{preset.name}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="environment-section">
        <div className="datetime-controls">
          <div className="datetime-group">
            <div className="datetime-item">
              <i className="fas fa-calendar"></i>
              <label>Date</label>
              <div className="environment-input-group">
                <input
                  type="text"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  className="environment-datetime-input"
                />
                <i className="fas fa-calendar-alt"></i>
              </div>
            </div>
            <div className="datetime-item">
              <i className="fas fa-clock"></i>
              <label>Time</label>
              <div className="environment-input-group">
                <input
                  type="text"
                  value={time}
                  onChange={(e) => setTime(e.target.value)}
                  className="environment-datetime-input"
                />
                <i className="fas fa-chevron-down"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="environment-section">
        <div className="lighting-controls">
          <div className="checkbox-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={useSoftShadows}
                onChange={(e) => setUseSoftShadows(e.target.checked)}
              />
              <span className="checkmark"></span>
              Use soft shadows
            </label>
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={enableShadows}
                onChange={(e) => setEnableShadows(e.target.checked)}
              />
              <span className="checkmark"></span>
              Enable shadows
            </label>
          </div>

          <div className="slider-group">
            <div className="slider-item">
              <label>Shadow intensity:</label>
              <div className="slider-container">
                <input
                  type="range"
                  min="0"
                  max="1"
                  step="0.1"
                  value={shadowIntensity}
                  onChange={(e) => setShadowIntensity(parseFloat(e.target.value))}
                  className="slider"
                />
                <i className="fas fa-pause"></i>
              </div>
            </div>
            <div className="slider-item">
              <label>Lighting intensity:</label>
              <div className="slider-container">
                <input
                  type="range"
                  min="0"
                  max="1"
                  step="0.1"
                  value={lightingIntensity}
                  onChange={(e) => setLightingIntensity(parseFloat(e.target.value))}
                  className="slider"
                />
                <i className="fas fa-pause"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="environment-section">
        <div className="action-buttons">
          <button className="action-btn primary">Save Custom</button>
          <button className="action-btn secondary">Reset Custom</button>
        </div>
      </div>

      <div className="environment-section">
        <div className="location-info">
          <div className="location-item">
            <i className="fas fa-globe"></i>
            <span>Latitude: none</span>
          </div>
          <div className="location-item">
            <i className="fas fa-globe"></i>
            <span>Longitude: none</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Environment;